<div nz-row>
  <div nz-col [nzSpan]="24">
    <div class="graphic-dot"></div>
    <div class="form-title">
      {{ 'ACTIVATE_ACCOUNT_PAGE.SET_PASSWORD_AND_ACTIVATE_ACCOUNT' | translate }}
    </div>
  </div>
</div>

<form nz-form [formGroup]="activateAccount.form" class="activate-account-form">
  <nz-spin
    class="mobiapp-spin login-spin"
    [nzSpinning]="activateAccount.authActionLoading$ | async"
    nzTip="{{ 'COMMON.LAYOUT.LOADING' | translate }}"
    nzSize="large"
    [nzIndicator]="LoadingIndicator">
    <nz-form-item [class.has-hint]="!activateAccount.form.controls.password.dirty">
      <nz-form-label [nzSpan]="24" nzRequired nzFor="activateAccountPassword">
        {{ 'COMMON.LABEL.PASSWORD' | translate }}
      </nz-form-label>
      <nz-form-control [nzSpan]="24" nzErrorTip="{{ 'ACTIVATE_ACCOUNT_PAGE.INVALID_PASSWORD' | translate }}">
        <nz-input-group [nzSuffix]="suffixTemplate">
          <input
            nz-input
            id="activateAccountPassword"
            [type]="activateAccount.isPasswordVisible ? 'text' : 'password'"
            (focus)="activateAccount.scrollToInput($event)"
            formControlName="password"
            placeholder="{{ 'COMMON.PLACEHOLDER.ENTER_PASSWORD' | translate }}"
            required />
        </nz-input-group>
        <ng-template #suffixTemplate>
          <button
            type="button"
            class="toggle-password-btn"
            tabindex="-1"
            [attr.aria-label]="'ACTIVATE_ACCOUNT_PAGE.SHOW_HIDE_PASSWORD' | translate"
            (click)="activateAccount.isPasswordVisible = !activateAccount.isPasswordVisible">
            <i nz-icon [nzType]="activateAccount.isPasswordVisible ? 'eye-invisible' : 'eye'"></i>
          </button>
        </ng-template>
        @if (!activateAccount.form.controls.password.dirty) {
          <div class="hint">
            {{ 'ACTIVATE_ACCOUNT_PAGE.PASSWORD_HINT' | translate }}
          </div>
        }
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="24" nzRequired nzFor="activateAccountPasswordConfirmation">
        {{ 'COMMON.LABEL.CONFIRM_PASSWORD' | translate }}
      </nz-form-label>
      <nz-form-control
        [nzSpan]="24"
        nzErrorTip="{{ 'ACTIVATE_ACCOUNT_PAGE.INVALID_PASSWORD_CONFIRMATION' | translate }}">
        <nz-input-group [nzSuffix]="suffixConfirmTemplate">
          <input
            nz-input
            id="activateAccountPasswordConfirmation"
            [type]="activateAccount.isPasswordConfirmVisible ? 'text' : 'password'"
            (focus)="activateAccount.scrollToInput($event)"
            formControlName="passwordConfirmation"
            placeholder="{{ 'COMMON.PLACEHOLDER.ENTER_CONFIRM_PASSWORD' | translate }}"
            required />
        </nz-input-group>
        <ng-template #suffixConfirmTemplate>
          <button
            type="button"
            class="toggle-password-btn"
            tabindex="-1"
            [attr.aria-label]="'ACTIVATE_ACCOUNT_PAGE.SHOW_HIDE_PASSWORD' | translate"
            (click)="activateAccount.isPasswordConfirmVisible = !activateAccount.isPasswordConfirmVisible">
            <i nz-icon [nzType]="activateAccount.isPasswordConfirmVisible ? 'eye-invisible' : 'eye'"></i>
          </button>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    @if (activateAccount.pinRequired) {
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired nzFor="activateAccountPIN">
          {{ 'ACTIVATE_ACCOUNT_PAGE.PIN' | translate }}
        </nz-form-label>
        <nz-form-control [nzSpan]="24" nzErrorTip="{{ 'COMMON.ERROR.WRONG_PIN' | translate }}">
          <input
            nz-input
            id="activateAccountPIN"
            type="password"
            (focus)="activateAccount.scrollToInput($event)"
            formControlName="pin"
            placeholder="PIN"
            autocomplete="off"
            required />
        </nz-form-control>
      </nz-form-item>
    }

    @if (activateAccount.gapRequired) {
      <nz-form-item class="terms-form-item">
        <nz-form-label
          class="terms-label"
          [nzXs]="22"
          [nzSm]="22"
          [nzSpan]="22"
          [nzNoColon]="true"
          nzRequired
          nzFor="hasAcceptedGDPR">
          <p class="label-text">
            {{ 'ACTIVATE_ACCOUNT_PAGE.TOS_GDPR_ACCEPTANCE.STEP_1_CONFIRM' | translate }}
            <a [routerLink]="['/tos']">
              {{ 'NEW_ACCOUNT.TOS_GDPR_ACCEPTANCE.TOS' | translate }}
            </a>
            {{ 'ACTIVATE_ACCOUNT_PAGE.TOS_GDPR_ACCEPTANCE.STEP_2_OR' | translate }}
            <a [routerLink]="['/privacy-policy']">
              {{ 'NEW_ACCOUNT.TOS_GDPR_ACCEPTANCE.PRIVACY_POLICY' | translate }}
            </a>
            {{ 'ACTIVATE_ACCOUNT_PAGE.TOS_GDPR_ACCEPTANCE.STEP_3_ACCEPT' | translate }}
          </p>
        </nz-form-label>
        <nz-form-control [nzSpan]="2" [nzXs]="2" [nzSm]="2">
          <label nz-checkbox name="hasAcceptedGDPR" formControlName="hasAcceptedGDPR" required> </label>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="terms-form-item">
        <nz-form-label
          class="terms-label complex"
          [nzNoColon]="true"
          [nzSpan]="22"
          nzRequired
          nzFor="hasAcceptedDataProcessing">
          <div class="label-text">
            {{
              activateAccount.termsAcceptanceShownFully
                ? ('ACTIVATE_ACCOUNT_PAGE.DATA_PROCESSING_ACCEPTANCE' | translate)
                : ('ACTIVATE_ACCOUNT_PAGE.DATA_PROCESSING_ACCEPTANCE_SHORT' | translate)
            }}
            @if (!activateAccount.termsAcceptanceShownFully) {
              <span
                class="suffix-text"
                (click)="activateAccount.termsAcceptanceShownFully = !activateAccount.termsAcceptanceShownFully"
                [innerHTML]="'ACTIVATE_ACCOUNT_PAGE.SHOW_FULL_ACCEPTANCE_CONTENT' | translate"></span>
            }
          </div>
        </nz-form-label>
        <nz-form-control [nzSpan]="2">
          <label nz-checkbox name="hasAcceptedDataProcessing" formControlName="hasAcceptedDataProcessing" required>
          </label>
        </nz-form-control>
      </nz-form-item>
    }

    <div nz-row>
      <div nz-col [nzSpan]="24">
        <button
          (click)="activateAccount.submitForm()"
          class="submit-button"
          id="activateAccountSubmitButton"
          [disabled]="
            activateAccount.form.pristine ||
            (activateAccount.form.dirty && activateAccount.form.invalid) ||
            (activateAccount.authActionLoading$ | async)
          "
          mat-raised-button
          color="primary">
          {{ 'ACTIVATE_ACCOUNT_PAGE.ACTIVATE_ACCOUNT' | translate }}
        </button>
      </div>
    </div>

    @if (activateAccount.form.get('passwordConfirmation')?.dirty && activateAccount.form.errors?.noMatch) {
      <div class="error-message-container">
        {{ 'ACTIVATE_ACCOUNT_PAGE.PASSWORDS_DO_NOT_MATCH' | translate }}
      </div>
    }

    @if (activateAccount.errorMessage$ | async; as errorMessage) {
      <div id="activateAccountErrorMessage" class="error-message-container">
        @switch (errorMessage) {
          @case ('COMMON.ERROR.USER_IS_ALREADY_ACTIVE') {
            <div>
              <div
                class="main-error-message"
                [innerHTML]="'ACTIVATE_ACCOUNT_PAGE.ERRORS.USER_IS_ALREADY_ACTIVE' | translate"></div>
              <div class="error-links">
                <a (click)="$event.preventDefault()" [routerLink]="['/login']">
                  {{ 'COMMON.REDIRECT.GO_TO_LOGIN' | translate }}
                </a>
                &nbsp;|&nbsp;
                <a (click)="$event.preventDefault()" [routerLink]="['/reset-password']">
                  {{ 'COMMON.REDIRECT.GO_TO_PASSWORD_RESET' | translate }}
                </a>
              </div>
            </div>
          }
          @case ('COMMON.ERROR.WRONG_PIN') {
            <div>
              <div class="main-error-message" [innerHTML]="'COMMON.ERROR.WRONG_PIN' | translate"></div>
            </div>
          }
          @case ('COMMON.ERROR.UNAUTHORIZED') {
            <div>
              <div
                class="main-error-message"
                [innerHTML]="'ACTIVATE_ACCOUNT_PAGE.ERRORS.UNAUTHORIZED' | translate"></div>
              <div class="error-explanations">
                <ul>
                  <li [innerHTML]="'ACTIVATE_ACCOUNT_PAGE.CHECK_EMAIL_WITH_LINK' | translate"></li>
                  <li [innerHTML]="'ACTIVATE_ACCOUNT_PAGE.ACTIVATION_LINK_EXPIRATION' | translate"></li>
                  <li [innerHTML]="'ACTIVATE_ACCOUNT_PAGE.IF_DATE_VALID_THEN_LINK_WRONG' | translate"></li>
                  <li [innerHTML]="'ACTIVATE_ACCOUNT_PAGE.IF_DATE_VALID_THEN_LINK_WRONG_2' | translate"></li>
                  <li [innerHTML]="'ACTIVATE_ACCOUNT_PAGE.CONTACT_US' | translate"></li>
                </ul>
              </div>
            </div>
          }
        }
      </div>
    }
  </nz-spin>
</form>

<ng-template #LoadingIndicator>
  <span nz-icon nzType="loading" class="ant-spin-dot"></span>
</ng-template>
